import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorIcon from '@mui/icons-material/Error';
import { Typography } from '@mui/material';
import { Popup } from '@elements';
import { StyledContent, StyledHeader, StyledPopup } from './error.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ErrorPopup = function ErrorPopup(_ref) {
  var rejectPopup = _ref.rejectPopup,
      popUp = _ref.popUp;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var header = popUp && popUp.data && popUp.data.header || t('components.popups.error.title');
  var body = popUp && popUp.data && popUp.data.body || t('components.popups.error.description');
  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 422,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(ErrorIcon, {
          fontSize: "large",
          color: "error",
          sx: {
            height: 48,
            width: 48
          }
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsxs(StyledContent, {
        flexDirection: "column",
        children: [header && /*#__PURE__*/_jsx(Typography, {
          color: "textPrimary",
          variant: "h4",
          textAlign: "center",
          children: header
        }), body && /*#__PURE__*/_jsx(Typography, {
          color: "textPrimary",
          variant: "body1",
          textAlign: "center",
          pt: header ? 2 : undefined,
          children: body
        })]
      })
    })]
  });
};

export { ErrorPopup };